import { render, staticRenderFns } from "./CouponsManagement.vue?vue&type=template&id=7a55ca24&scoped=true&lang=pug"
import script from "./CouponsManagement.vue?vue&type=script&lang=js"
export * from "./CouponsManagement.vue?vue&type=script&lang=js"
import style0 from "./CouponsManagement.vue?vue&type=style&index=0&id=7a55ca24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55ca24",
  null
  
)

export default component.exports